<div>
    <div style="margin-left: 70%;  margin-bottom: 2%">
        <!-- <button class="btn btn-info" mat-raised-button (click)="assigndisrep()">
                Add Distribution Rep.
            </button> -->
        <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
            print
        </button>
        <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <div class="row rowborder hc mx-3 pt-3">
                <div class="common ml-3" style="color: rgb(0, 183, 255);">
                    <span>दिनांक : {{ getFormattedDate() }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span style="margin-left:-60px">पृष्ठ क्र : 1</span>
                </div>
                <div class="common" style="margin: 0px 80px 10px 90px;">
                    <span style="font-size: 22px;color: red;">हिंदुस्थान प्रकाशन संस्था</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span style="margin-left:35px; font-size: 20px; color: blue;">ऊप खात्यांचा ट्रायल बॅलन्स मुख्य खाते
                        -
                        {{exp_name}}</span>
                </div>
                <div class="common mr-3" style="color: rgb(0, 183, 255);">
                    <span>दिनांक पासून : </span>
                    <span>{{ startDate | date: 'dd-MM-yyyy' }}</span>
                    <div style=" margin-bottom: 10px;"></div>
                    <span>दिनांक पर्यंत : </span>
                    <span>{{ endDate | date: 'dd-MM-yyyy' }}</span>
                </div>
            </div>
            <div class="row rowborder mx-3" style="gap: 0;">

                <div class="col-3" style="margin-left: 60px;">
                    <span class="fw_600" style="font-size: 20px;">खात्याचे नाव </span>
                </div>
                <div class="col-3" style="text-align: center;">
                    <span class="fw_600" style="font-size: 20px;">डेबिट </span>
                </div>
                <div class="col-3" style="text-align: center;">
                    <span class="fw_600" style="font-size: 20px;margin-right:40px">क्रेडिट </span>
                </div>
            </div>
            <!-- <hr style="margin:0px 0px 0px 0px"> -->

            <div class="row mx-3 rowborder" *ngFor="let item of alldebitvoucher1">
                <div class="col-3" style="margin-left: 60px;">
                    <span>{{ item['sub_exp_name'] }}</span>

                </div>
                <div class="col-3" style="text-align: right;margin-right: 40px;">
                    <span class="mr-5">{{ item['total_debit_amount']
                        }} </span>
                </div>
                <div class="col-3" style="text-align: right;margin-right: 80px;">
                    <span class="mr-5">{{ item['total_credit_amount']
                        }}</span>
                </div>
            </div>
            <hr style="margin:0px 0px 0px 0px">
            <div class="row rowborder rowbordertop mx-3" style="gap: 0;">
                <div class="col-3 common" style="margin-left: 60px;">
                    <span class="fw_600" style="font-size: 20px;">एकूण :</span>
                </div>
                <div class="col-3" style="text-align: right;margin-right: 40px;">
                    <span class="fw_600 mr-5" style="font-size: 20px;">{{ getTotalDebit() | number:'1.2-2' }}</span>
                </div>
                <div class="col-3" style="text-align: right;margin-right: 40px;">
                    <span class="fw_600 mr-5" style="font-size: 20px;">{{ getTotalCredit() | number:'1.2-2' }}</span>
                </div>
            </div>
        </div>
        <print-preview-layout-settings class="settings-section"></print-preview-layout-settings>

    </div>
</div>